
















import { Component, Mixins } from "vue-property-decorator";
import PlanForm from "hfox/components/plan/PlanForm.vue";
import LPPlanTip from "hfox/components/plan/LPPlanTip.vue";
import { Plan } from "@foxone/api/src/models/hfox";
import { Getter } from "vuex-class";
import mixins from "@/mixins";
import utils from "hfox/utils";

@Component({
  components: {
    PlanForm,
    "lp-plan-tip": LPPlanTip
  }
})
class EditPlan extends Mixins(mixins.page) {
  @Getter("hfox/getPlanById") getPlanById;

  submitting = false;

  plan: Plan | null = null;

  // get plan(): Plan {
  //   return this.getPlanById(this.id);
  // }

  get id() {
    return this.$route.params.id as string;
  }

  get title() {
    return this.$t("hfox.plan.edit") as string;
  }

  get isLP() {
    return this.plan?.etf.is_lp_token;
  }

  get bindPlan() {
    if (!this.plan) {
      return {};
    }
    return {
      name: this.plan.name,
      etf: this.plan.etf_name,
      period: this.plan.period,
      funds: this.plan.funds
    };
  }

  get etfs() {
    return this.$store.state.hfox.etfs;
  }

  mounted() {
    const plan = this.getPlanById(this.id);
    this.plan = {
      ...plan,
      period: utils.period.toUTCPeriod(plan.period, true)
    };
  }

  async handleSave() {
    this.submitting = true;
    await this.requestUpdatePlan();
    this.submitting = false;
  }

  async requestUpdatePlan() {
    try {
      const plan = {
        ...this.bindPlan,
        period: utils.period.toUTCPeriod(this.bindPlan.period)
      };
      await this.$api.hfox.requestUpdatePlan(this.plan?.id + "", plan);

      this.$common.utils.helper.toast(this, {
        message: this.$t("hfox.plan.edit.success") as string,
        color: "success"
      });
      this.toDetail();
      this.$store.dispatch("hfox/loadPlans");
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  toDetail() {
    this.$router.back();
  }
}
export default EditPlan;
